import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { Avatar, Box, Button, CircularProgress, Container, CssBaseline, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { verifyEmail } from '../../services/api';

const TEAL = '#6aabab';

export const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) {
            setStatus('error');
            return;
        }
        verifyEmail(token)
            .then(() => setStatus('success'))
            .catch(() => setStatus('error'));
    }, []);

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                {status === 'loading' && (
                    <>
                        <CircularProgress sx={{ color: TEAL }} />
                        <Typography variant="body1">Verificando seu e-mail...</Typography>
                    </>
                )}
                {status === 'success' && (
                    <>
                        <Avatar sx={{ bgcolor: 'success.main', width: 64, height: 64 }}>
                            <CheckCircleIcon sx={{ fontSize: 36 }} />
                        </Avatar>
                        <Typography component="h1" variant="h5" fontWeight="bold">
                            E-mail confirmado!
                        </Typography>
                        <Typography variant="body1" textAlign="center">
                            Sua conta foi ativada com sucesso. Agora você pode fazer login.
                        </Typography>
                        <Button
                            variant="contained"
                            sx={{ bgcolor: TEAL, '&:hover': { bgcolor: '#5a9898' } }}
                            onClick={() => navigate('/', { replace: true })}
                        >
                            Ir para o login
                        </Button>
                    </>
                )}
                {status === 'error' && (
                    <>
                        <Avatar sx={{ bgcolor: 'error.main', width: 64, height: 64 }}>
                            <ErrorIcon sx={{ fontSize: 36 }} />
                        </Avatar>
                        <Typography component="h1" variant="h5" fontWeight="bold">
                            Link inválido
                        </Typography>
                        <Typography variant="body1" textAlign="center">
                            O link de verificação é inválido ou já expirou. Tente se cadastrar novamente.
                        </Typography>
                        <Button
                            variant="outlined"
                            sx={{ color: TEAL, borderColor: TEAL }}
                            onClick={() => navigate('/', { replace: true })}
                        >
                            Voltar para a página inicial
                        </Button>
                    </>
                )}
            </Box>
        </Container>
    );
};
